import CarouselPage from "./CarouselPage";
import Vision from "./Vision";
import AboutUS from "./AboutUs.jsx";
function Home() {
  return (
    <>
      <CarouselPage />
      <Vision />
      <AboutUS />
    </>
  );
}

export default Home;
